import React from 'react';
import { LinkText } from '../../shared/Link';
import Text from '../../shared/Text';
import { FAQol } from './styles';

const STEPS_TO_SWITCH = [
  {
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/import-icon.png',
    retinaImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/import-icon@2x.png',
    title: 'Import to Anchor',
    description:
      'It only takes a second to import your episodes; no manual uploading required.',
  },
  {
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/redirect-icon.png',
    retinaImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/redirect-icon@2x.png',
    title: 'Redirect your old feed',
    description:
      "This way, your listeners will be able to hear your new episodes. This won't impact your existing listing, reviews, or subscribers.",
  },
  {
    imageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/mic-icon.png',
    retinaImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/mic-icon@2x.png',
    title: "That's it!",
    description:
      'Start making your future episodes with Anchor. Either upload your audio as-is or use our built-in tools to edit.',
  },
];

const FAQS = [
  {
    question: 'Is Anchor really free? How is that possible?',
    renderAnswer: () => (
      <>
        <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
          Anchor&#39;s mission is to provide easy and powerful podcasting tools
          for everyone. Because of this, our platform is completely free to
          se–there&#39;s no hosting fees, trial periods, or paywalls.
        </Text>
        <br />
        <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
          With the low cost of file storage today,{' '}
          <LinkText
            to="https://medium.com/@NirZicherman/why-you-should-never-pay-for-podcast-hosting-9c39becd7cf7"
            isInline={true}
          >
            <Text
              size="md"
              sizeAtSmScreen="sm"
              align="left"
              isInline={true}
              color="#8940FA"
              isBold={true}
            >
              podcasters should not have to pay money to host their show online
            </Text>
            .
          </LinkText>
        </Text>
        <br />
        <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
          Our philosophy is that companies and podcasters should make money
          together, rather than profiting off each other&#39;s needs. When
          podcasters collect revenue using Anchor Sponsorships, Anchor takes a
          30% share, which is how we keep our tools free for everyone.
        </Text>
        <br />
        <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
          Read more about why Anchor is free{' '}
          <LinkText
            to="https://medium.com/@NirZicherman/why-you-should-never-pay-for-podcast-hosting-9c39becd7cf7"
            isInline={true}
          >
            <Text
              size="md"
              sizeAtSmScreen="sm"
              align="left"
              isInline={true}
              color="#8940FA"
              isBold={true}
            >
              here
            </Text>
          </LinkText>
          .
        </Text>
      </>
    ),
  },
  {
    question: 'Who owns the rights to my content if I use Anchor?',
    renderAnswer: () => (
      <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
        You do, 100%. Anchor creators always have and always will retain
        complete ownership of their content.
      </Text>
    ),
  },
  {
    question:
      'Do I have to use Anchor’s creation tools or can I upload my own finished audio?',
    renderAnswer: () => (
      <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
        If you want to produce your show using another app, you&#39;re
        absolutely free to do so. You can upload your own audio to Anchor
        directly from our website or mobile apps and still take advantage of our
        free hosting, monetization, and more. Anchor also makes it easy to
        convert video files to audio, in case you prefer to record your content
        via video.
      </Text>
    ),
  },
  {
    question: 'What if I change my mind about switching to Anchor?',
    isSwitchQuestion: true,
    renderAnswer: () => (
      <>
        <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
          If at Anchor point you decide that Anchor isn&#39;t right for you,
          it&#39;s easy to switch back to your old host.
        </Text>
        <br />
        <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
          Keep in mind that the &quot;switch&quot; happens when you redirect
          your RSS feed to Anchor. After importing your episodes, you&#39;ll
          have plenty of time to click around and test Anchor&#39;s features
          before redirecting your RSS feed. That way, you can make sure Anchor
          is the right platform for you before making the switch.
        </Text>
      </>
    ),
  },
  {
    question: 'Will my podcast be unavailable during the switching process?',
    isSwitchQuestion: true,
    renderAnswer: () => (
      <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
        There&#39;s zero down time during switching. Redirecting your feed from
        your old host to Anchor is instantaneous, and listeners will be able to
        access your podcast during the process. Switching only takes a few
        minutes and happens completely behind the scenes, meaning it won&#39;t
        have any impact on your podcast listing or your subscribers.
      </Text>
    ),
  },
  {
    question:
      'Will my subscribers see any changes or have to refollow me after I switch to Anchor?',
    isSwitchQuestion: true,
    renderAnswer: () => (
      <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
        Nope! From your listeners&#39; perspective, it&#39;ll be like nothing
        happened. All your subscribers will remain intact, and they&#39;ll
        continue to find and listen to your show wherever it&#39;s available.
      </Text>
    ),
  },
  {
    question: 'How do I redirect my feed from my current host to Anchor?',
    isSwitchQuestion: true,
    renderAnswer: () => (
      <>
        <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
          This may differ slightly depending on which current hosting platform
          you use, but this is the general process:
        </Text>
        <br />
        <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
          <FAQol>
            <li>Log into your old host&#39;s website.</li>
            <li>Go to settings.</li>
            <li>
              Look for an option that says something like &quot;Redirect
              URL&quot; or &quot;Enable Redirect&quot; and toggle it on.
            </li>
            <li>
              Paste your new Anchor RSS feed in the text field (your new Anchor
              RSS feed will show up on your Anchor dashboard once your episodes
              import successfully).
            </li>
            <li>Save changes.</li>
          </FAQol>
        </Text>
        <br />
        <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
          Anchor has a number of{' '}
          <LinkText
            isInline={true}
            to="https://help.anchor.fm/hc/en-us/articles/360023100411-Switching-your-podcast-to-Anchor"
          >
            <Text
              size="md"
              sizeAtSmScreen="sm"
              align="left"
              isInline={true}
              color="#8940FA"
              isBold={true}
            >
              help articles
            </Text>
          </LinkText>{' '}
          detailing the specific steps to redirect your feed from different
          platforms (including Libsyn, Blubrry, Podbean, Buzzsprout, and more).
        </Text>
      </>
    ),
  },
  {
    question: 'How exactly does distribution work?',
    isSwitchQuestion: true,
    renderAnswer: () => (
      <>
        <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
          When you&#39;re ready to share your show, Anchor can automatically
          submit your RSS feed to all major listening platforms, including
          Spotify, Apple Podcasts, Google Podcasts, and more—all it takes is a
          single click. If your podcast is already distributed to any of these
          platforms, just add the URLs of the respective podcast listings to
          your Anchor profile to avoid duplicate submissions. Anchor can also
          help distribute your show to additional platforms to ensure all
          listeners have easy access to your podcast.
        </Text>
        <br />
        <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
          Prefer to manage your RSS feed and handle distribution yourself? No
          problem, Anchor also makes it easy to distribute your show manually.
        </Text>
      </>
    ),
  },
  {
    question:
      'What if I want to make changes to my episodes after I switch to Anchor?',
    isSwitchQuestion: true,
    renderAnswer: () => (
      <>
        <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
          Once you import your podcast to Anchor, changes you make to any
          episodes on your old host will no longer be reflected; going forward,
          please make edits directly to your episodes within Anchor.
        </Text>
      </>
    ),
  },
  {
    question: 'Still have questions?',
    isSwitchQuestion: true,
    renderAnswer: () => (
      <Text size="md" sizeAtSmScreen="sm" align="left" color="#000000">
        Get in touch with us{' '}
        <LinkText
          to="https://anchorhq.typeform.com/to/QzuiVt"
          target="_self"
          isInline={true}
        >
          <Text
            size="md"
            sizeAtSmScreen="sm"
            color="#8940FA"
            isInline={true}
            isBold={true}
          >
            here
          </Text>
        </LinkText>
        . We look forward to hearing from you!
      </Text>
    ),
  },
];

const QUOTES = [
  {
    imgWidth: 500,
    isReverse: true,
    podcastCoverartImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/optimal-living-daily.jpg',
    podcastCoverartImageRetinaUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/optimal-living-daily@2x.jpg',
    authorName: 'Justin Malik',
    podcastUrl:
      'https://open.spotify.com/show/1hygb4nGhNhlLn4pBnN00j?si=7zlH4H6LRcWkkX3bHhbQPQ',
    podcastName: 'Optimal Living Daily',
    quote:
      "Podcasting since 2015, we've seen our fair share of analytics, but Anchor has given us the clearest view into our audience demographics through their analytics dashboard, including gender and age, which we haven't seen anywhere else. Anchor's analytics has completely changed how we shape our new episodes--we can cater to our audience better than ever before.",
  },
  {
    imgWidth: 350,
    isReverse: false,
    podcastCoverartImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/alyssa-milano.jpg',
    podcastCoverartImageRetinaUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/alyssa-milano@2x.jpg',
    authorName: 'Alyssa Milano',
    podcastUrl:
      'https://open.spotify.com/show/4QulLIG8eNtgysQuhUWr9F?si=BfrKeumjTBe0CaglG0_IWg',
    podcastName: 'Sorry Not Sorry',
    quote:
      "Switching to Anchor was so easy because the creator team did all the work for us. It was great to be in constant contact with a team of people committed to making sure the tech and distribution was handled so we could focus on what we do best – making a great podcast. If you're thinking of switching, you should!",
  },
  {
    imgWidth: 350,
    isReverse: false,
    podcastCoverartImageUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/colin-samir.jpg',
    podcastCoverartImageRetinaUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/colin-samir@2x.jpg',
    authorName: 'Colin and Samir',
    podcastUrl:
      'https://open.spotify.com/show/5QaSbbv2eD4SFrlFR6IyY7?si=7wzsevLiTlqLK9L4MqRlZw',
    podcastName: 'The Colin and Samir Podcast',
    quote:
      'Our favorite feature to use is 100% the Anchor Voice Messages feature. Hearing from the people that listen makes it all worth it.',
  },
];

const FEATURES = [
  {
    header: 'Earn more with free hosting and monetization.',
    subheader:
      'Upload an unlimited number of episodes – no monthly fees, no trial period, no catch.',
    width: '190px',
    assetUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/spotify-sponsorships@2x.jpg',
    smAssetUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/spotify-sponsorships.jpg',
    info: (
      <>
        <Text size="md" sizeAtSmScreen="sm" align="left">
          Anchor Sponsorships (available in the US, expanding soon) makes it
          easy to feature audio ads on your podcast so that you earn money, no
          matter your audience size. Ads are optional, customizable, and read by
          you.
        </Text>
        <br />
        <Text size="md" sizeAtSmScreen="sm" align="left">
          Of course, you can also keep all your own sponsorship deals; Anchor
          analytics are IAB Certified so you can confidently work with new and
          existing advertisers.
        </Text>
      </>
    ),
    altText:
      'An image of icons with dollar signs, and an interface for ad insertion',
  },
  {
    header: 'Focus on creating, we’ll take care of the rest.',
    subheader:
      'Anchor is built to put creating at the forefront and automate the technical side of podcasting. If your podcast is not yet available on all listening platforms, Anchor will distribute it everywhere with a single click so you can reach a wider audience instantly.',
    width: '190px',
    assetUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/distro-free@2x.jpg',
    smAssetUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/distro-free.jpg',
    info: (
      <>
        <Text size="md" sizeAtSmScreen="sm" align="left">
          Network support (currently in a closed beta) is available to certain
          users upon request, so you can quit toggling and manage all your
          podcasts under one account.
        </Text>
        <br />
        <Text size="md" sizeAtSmScreen="sm" align="left">
          Our creator support team is here to help. Talk to real people (we’re
          podcasters ourselves) whenever you need us.
        </Text>
      </>
    ),
    altText:
      'An image of a media player with the logos to the platforms you can distribute your podcast to',
  },
  {
    header: 'Stay in control, at no cost.',
    subheader:
      'When you switch to Anchor, your podcast won’t experience any downtime or duplicate listings, and you’ll keep all of your subscribers in the process.',
    width: '145px',
    assetUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/phone-graphic@2x.jpg',
    smAssetUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/phone-graphic.jpg',
    info: (
      <>
        <Text size="md" sizeAtSmScreen="sm" align="left">
          If you decide at any point that Anchor isn’t for you, switch back
          whenever without skipping a beat.
        </Text>
        <br />
        <Text size="md" sizeAtSmScreen="sm" align="left">
          Keep 100% ownership of your content{' '}
          <LinkText
            to="https://blog.anchor.fm/why-anchor-is-free"
            target="_self"
            isInline={true}
          >
            (learn more about why Anchor is free)
          </LinkText>
        </Text>
      </>
    ),
    altText: 'A graphic of a hand with a phone with Anchor on the screen',
  },
  {
    header: 'Unparalleled analytics, powered by Spotify.',
    subheader:
      'Having the right data means being able to strategically grow your audience and optimize your content.  Anchor analytics collects stats from multiple platforms to show you how your podcast is performing over time, along with detailed episode dropoff charts and aggregated age and gender breakdowns for your Spotify listeners, all in one place.',
    width: '190px',
    assetUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/analytics-images@2x.jpg',
    smAssetUrl:
      'https://d12xoj7p9moygp.cloudfront.net/images/screens/import/analytics-images.jpg',
    info: (
      <Text size="md" sizeAtSmScreen="sm" align="left">
        This data is derived from actual streaming behavior (not just download
        counts), giving you second-by-second insight into how listeners are
        engaging with your episodes.
      </Text>
    ),
    altText:
      'An image of graphs and charts that represent realtime streaming data',
  },
];

export { STEPS_TO_SWITCH, FAQS, QUOTES, FEATURES };
